import { Component, ViewChild } from "@angular/core";
import { LifeCoverDesktopBenefitsDrawerComponent } from "./life-cover-desktop-benefits-drawer/life-cover-desktop-benefits-drawer.component";
import { LifeCoverMobileBenefitsDrawerComponent } from "./life-cover-mobile-benefits-drawer/life-cover-mobile-benefits-drawer.component";
import { LifeCoverDesktopPremiumDrawerComponent } from "./life-cover-desktop-premium-drawer/life-cover-desktop-premium-drawer.component";
import { LifeCoverMobilePremiumDrawerComponent } from "./life-cover-mobile-premium-drawer/life-cover-mobile-premium-drawer.component";
import { InsuranceHubBaseComponent } from "../Insurance-hub-callback";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-life-cover",
  templateUrl: "./life-cover.component.html",
  styleUrls: ["./life-cover.component.css"],
  standalone: true,
  imports: [
    LifeCoverDesktopBenefitsDrawerComponent,
    LifeCoverMobileBenefitsDrawerComponent,
    LifeCoverDesktopPremiumDrawerComponent,
    LifeCoverMobilePremiumDrawerComponent,
    RouterModule
  ],
})
export class LifeCoverComponent extends InsuranceHubBaseComponent {
  @ViewChild("lifeCoverDesktopBenefitsDrawer")
  lifeCoverDesktopBenefitsDrawer!: LifeCoverDesktopBenefitsDrawerComponent;
  @ViewChild("lifeCoverMobileBenefitsDrawer")
  lifeCoverMobileBenefitsDrawer!: LifeCoverMobileBenefitsDrawerComponent;
  @ViewChild("lifeCoverDesktopPremiumDrawer")
  lifeCoverDesktopPremiumDrawer!: LifeCoverDesktopPremiumDrawerComponent;
  @ViewChild("lifeCoverMobilePremiumDrawer")
  lifeCoverMobilePremiumDrawer!: LifeCoverMobilePremiumDrawerComponent;

  private offcanvasInstances: { [key: string]: any } = {};

  drawerContent;
  ngOnInit(): void {
    this.GetPolicyDetailData();
  }

  GetPolicyDetailData() {
    let upolicyData = sessionStorage.getItem("UserPolicyDetails")
      ? JSON.parse(sessionStorage.getItem("UserPolicyDetails"))
      : null;
    if (upolicyData?.lifeCoverPolicyResponse) {
      this.PolicyDetailResponse = upolicyData.lifeCoverPolicyResponse;
    }
  }
  openLifeCoverDesktopBenefitsDrawer() {
    this.lifeCoverDesktopBenefitsDrawer.openDrawer(this.PolicyDetailResponse);
  }

  openLifeCoverMobileBenefitsDrawer() {
    this.lifeCoverMobileBenefitsDrawer.openDrawer(this.PolicyDetailResponse);
  }

  openLifeCoverDesktopPremiumDrawer() {
    this.lifeCoverDesktopPremiumDrawer.openDrawer(this.PolicyDetailResponse);
  }

  openLifeCoverMobilePremiumDrawer() {
    this.lifeCoverMobilePremiumDrawer.openDrawer(this.PolicyDetailResponse);
  }
}
